<template>
    <span v-if="readOnly">
        {{candidate}}
    </span>
    <div v-else>
        <input type="text" :class="{'text-danger':invalidState}"
               :placeholder="placeholder"
               v-model="candidate"
               @keyup="onKeyUp" @blur="onBlur" />
    </div>

</template>

<script>
    export default {
        name: "IntegerInput",
        props: {
            value: Number,
            minValue: Number,
            maxValue: Number,
            defaultValue: Number,
            readOnly: { type: Boolean, default: false },
            placeholder: { type: String, default: '' },
        },
        data() {
            return {
                candidate: this.value,
                validValue: null,
                invalidState: false,
                parsed: null
            }
        },
        mounted() {
            if (!this.value || this.value === 0) {
                console.log('this.defaultValue', this.defaultValue);
                this.$emit('onValueChanged', this.defaultValue)
                this.candidate = this.defaultValue
            }
        },
        methods: {
            isValid(data) {
                var reg = /^\d*\.?\d*$/;
                console.log(data);
                if (!reg.test(data)) {
                    this.invalidState = true;
                    return false;
                }
                else {
                    this.parsed = parseInt(data);
                    console.log(this.parsed);
                    if (this.minValue != null) {
                        console.log(this.minValue);
                        if (this.minValue > this.parsed)
                            this.candidate = this.minValue;
                    }
                    if (this.maxValue != null) {
                        console.log(this.maxValue);
                        if (this.maxValue < this.parsed)
                            this.candidate = this.maxValue;
                    }
                    this.invalidState = false;
                }

                return true;
            },
            onBlur(e) {
                var isValid = this.isValid(this.candidate);
                if (!isValid) {
                    this.candidate = this.value;
                }
                else {
                    this.$emit("onValueChanged", this.parsed);
                }
            },
            onKeyUp(e) {
                //console.log(e, this.candidate);
                var isValid = this.isValid(this.candidate);
                if (!isValid) {
                    this.candidate = this.value;
                }
                else {
                    this.$emit("onValueChanged", this.parsed);
                }
            },
        }
    }
</script>

<style scoped>
</style>
